import React, { createContext, useState } from "react";
import InputText from "./InputText";
import { useComponent } from "../common/Modal";
import { useForm } from "react-hook-form";
import {
  changePassword,
  userlogin,
  userSignup,
} from "../../services/apiServices";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ClipLoader } from "react-spinners"; // Loader Component
import { useAuthStore } from "../../redux/features/authSlice";
import { setToken } from "../../utils/axiosClient";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const ChangePasswordModal = ({ isOpen, onClose }) => {
  const [loading, setLoading] = useState(false);
  const { loginInfo } = useAuthStore();
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
    setValue,
    trigger,
    reset,
  } = useForm();
  const onSubmit = async (data) => {
    try {
      setToken(loginInfo ? loginInfo?.token : null);
      setLoading(true);
      const payload = {
        currentPassword: data?.old_password,
        newPassword: data?.password,
      };
      const response = await changePassword(payload);
      if (response?.data?.statusCode == 200) {
        onClose();
        toast.success(
          response?.data?.message || t("changepassword_success"),
          {
            position: "top-right",
            autoClose: 3000,
          }
        );
      } else {
        toast.error(
          response?.data?.message || t("changepassword_failed"),
          {
            position: "top-right",
            autoClose: 3000,
          }
        );
      }
    } catch (error) {
      console.warn("error in change password: ", error);
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div
      onClick={onClose}
      className="fixed inset-0 p-5 flex items-center justify-center bg-black bg-opacity-50 z-50"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="bg-white p-6 rounded-[30px] shadow-lg w-[450px]"
      >
        {/* Modal Header */}
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="overflow-y-scroll max-h-[500px]">
            <h2 className="text-2xl text-primary-text font-semibold text-center">
              {t("changepassword_title")}
            </h2>

            <h5 className="text-center mt-2 text-lg text-[#5D5D5D] font-medium">
              {t("changepassword_subtitle")}
            </h5>
            <InputText
              title={t("changepassword_old_password")}
              placeholder={t("changepassword_old_password_placeholder")}
              type="password"
              password={true}
              {...register("old_password", {
                required: t("changepassword_old_password_required"),
                minLength: {
                  value: 6,
                  message: t("changepassword_password_minlength"),
                },
              })}
              error={errors.old_password?.message}
              value={watch("old_password")}
              onChange={(e) => {
                setValue("old_password", e.target.value);
                trigger("old_password");
              }}
            />

            <InputText
              title={t("changepassword_new_password")}
              placeholder={t("changepassword_new_password_placeholder")}
              type="password"
              password={true}
              {...register("password", {
                required: t("changepassword_new_password_required"),
                minLength: {
                  value: 6,
                  message: t("changepassword_password_minlength"),
                },
              })}
              error={errors.password?.message}
              value={watch("password")}
              onChange={(e) => {
                setValue("password", e.target.value);
                trigger("password");
              }}
            />

            <InputText
              title={t("changepassword_confirm_password")}
              placeholder={t("changepassword_confirm_password_placeholder")}
              type="password"
              password={true}
              {...register("confirmPassword", {
                required: t("changepassword_confirm_password_required"),
                validate: (value) =>
                  value === watch("password") || t("changepassword_passwords_not_match"),
              })}
              error={errors.confirmPassword?.message}
              value={watch("confirmPassword")}
              onChange={(e) => {
                setValue("confirmPassword", e.target.value);
                trigger("confirmPassword");
              }}
            />

            <div className="mt-4 text-center">
              <button
                type="submit"
                className="w-full text-base bg-red-600 text-white p-3 rounded-[121px] font-semibold"
                disabled={loading}
              >
                {loading ? <ClipLoader size={20} color="#fff" /> : t("changepassword_continue")}
              </button>
              <button
                onClick={() => {
                  onClose();
                  // Example: redirect to home after cancel, respecting language
                  navigate(i18n.language === 'en' ? '/en' : '/');
                }}
                className="text-[#5D5D5D] text-base text-center mt-4 font-semibold"
                type="button"
              >
                {t("changepassword_cancel")}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ChangePasswordModal;
